/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { type AppDispatch } from '../../../store'
import { gatewayListErrorAction, gatewayListLoadingAction, gatewayListUpdateAction } from './gatewayListSlice'
import * as GatewayListService from '../services/gatewayListService'
import { gatewayDeleteErrorAction, gatewayDeleteLoadingAction, gatewayDeleteUpdateAction } from './gatewayDeleteSlice'
import * as GatewayDeleteService from '../services/gatewayDeleteService'
import { assetInfoLoadingAction, assetInfoUpdateAction, assetInfoErrorAction } from './assetInfoSlice'
import * as assetInfoService from '../services/assetInfoService'
import { assetCategoriesLoadingAction, assetCategoriesUpdateAction, assetCategoriesErrorAction } from './assetCategoriesSliceGateway'
import * as assetCategoriesService from '../services/assetCategoriesService'
import { gatewayTypeLoadingAction, gatewayTypeUpdateAction, gatewayTypeErrorAction } from './gatewayTypeSlice'
import * as gatewayTypeService from '../services/gatewayTypeService'
import { createGatewayLoadingAction, createGatewayUpdateAction, createGatewayErrorAction } from './createGatewaySlice'
import { type CreateGatewayApiResponse, type CreateGatewayPostRequest } from '../services/createGatewayService'
import * as CreateGatewayService from '../services/createGatewayService'
import { type ImageUploadApiResponse, type ImageUploadPostRequest } from '../services/imageUploadService'
import * as ImageUploadService from '../services/imageUploadService'
import { ImageUploadLoadingAction, ImageUploadUpdateAction, ImageUploadErrorAction } from './imageUploadSliceGateway'
import { updateGatewayLoadingAction, updateGatewayUpdateAction, updateGatewayErrorAction } from './updateGatewaySlice'
import { type UpdateGatewayApiResponse, type UpdateGatewayPutRequest } from '../services/updateGatewayService'
import * as UpdateGatewayService from '../services/updateGatewayService'
import { downloadImageLoadingAction, downloadImageUpdateAction, downloadImageErrorAction } from './downloadImageSliceGateway'
import * as downloadImageService from '../services/downloadImageService'
import { gatewayInfoErrorAction, gatewayInfoLoadingAction, gatewayInfoUpdateAction } from './gatewayInfoSliceGateway'
import { gatewayInfoService } from '../services/gatewayInfoService'
import * as timezoneService from '../services/timezoneService'
import { TimezoneDropDownLoadingAction, TimezoneDropDownUpdateAction, TimezoneDropDownErrorAction } from './timezoneDataSlice'

export const fetchGatewayList =
  (siteId: string, assetTypeId: string, PageNumber: number, PageItems: number, searchKey: string, SortParams: string, parentAssetId: string, sortField: string) =>
    async (dispatch: any): Promise<void> => {
      dispatch(gatewayListLoadingAction())
      void GatewayListService.getGatewayList(
        siteId,
        assetTypeId,
        PageNumber,
        PageItems,
        searchKey,
        SortParams,
        parentAssetId,
        sortField,
        (gatewayList, httpStatus) => {
          dispatch(
            gatewayListUpdateAction({
              data: gatewayList.assets,
              count: gatewayList.total_count,
              httpStatus
            })
          )
        },
        (errorMessage, httpStatus) => {
          dispatch(gatewayListErrorAction({ errorMessage, httpStatus }))
        }
      )
    }

export const gatewayDeleteCampaign = (selectedGatewayId: string) => async (dispatch: any): Promise<void> => {
  dispatch(gatewayDeleteLoadingAction())
  void GatewayDeleteService.gatewayDeleteCampaign(selectedGatewayId,
    (deleteStatusData, httpStatus) => {
      dispatch(
        gatewayDeleteUpdateAction({
          data: deleteStatusData,
          httpStatus
        })
      )
    },
    (errorMessage, httpStatus) => {
      dispatch(gatewayDeleteErrorAction({ errorMessage, httpStatus }))
    }
  )
}

export const fetchAssetInfo = (selectedGatewayId: string) => async (dispatch: any): Promise<void> => {
  dispatch(assetInfoLoadingAction())
  void assetInfoService.assetInfoService(selectedGatewayId,
    (deleteStatusData, httpStatus) => {
      dispatch(
        assetInfoUpdateAction({
          data: deleteStatusData,
          httpStatus
        })
      )
    },
    (errorMessage, httpStatus) => {
      dispatch(assetInfoErrorAction({ errorMessage, httpStatus }))
    }
  )
}

export const fetchAssetCategories = () =>
  async (dispatch: any): Promise<void> => {
    dispatch(assetCategoriesLoadingAction())
    // eslint-disable-next-line @typescript-eslint/no-confusing-void-expression
    void assetCategoriesService.assetCategoriesService(
      (assetCategoryData, httpStatus) => {
        dispatch(
          assetCategoriesUpdateAction({
            data: assetCategoryData,
            httpStatus
          })
        )
      },
      (errorMessage, httpStatus) => {
        dispatch(assetCategoriesErrorAction({ errorMessage, httpStatus }))
      }
    )
  }

export const fetchGatewayType = (categoryTypeId: string) =>
  async (dispatch: any): Promise<void> => {
    dispatch(gatewayTypeLoadingAction())
    // eslint-disable-next-line @typescript-eslint/no-confusing-void-expression
    void gatewayTypeService.gatewayTypeService(
      categoryTypeId,
      (gatewayTypeData, httpStatus) => {
        dispatch(
          gatewayTypeUpdateAction({
            data: gatewayTypeData,
            httpStatus
          })
        )
      },
      (errorMessage, httpStatus) => {
        dispatch(gatewayTypeErrorAction({ errorMessage, httpStatus }))
      }
    )
  }

// istanbul ignore next
export const createGateway = (createGatewayPostRequest: CreateGatewayPostRequest) => async (dispatch: AppDispatch): Promise<void> => {
  dispatch(createGatewayLoadingAction())
  void CreateGatewayService.createGateway(
    createGatewayPostRequest,
    (CreateGatewayApiResponse: CreateGatewayApiResponse, httpStatus: number) => {
      dispatch(
        createGatewayUpdateAction({
          data: CreateGatewayApiResponse, httpStatus
        })
      )
    },
    (errorMessage, httpStatus) => {
      dispatch(createGatewayErrorAction({ errorMessage, httpStatus }))
    }
  )
}

// istanbul ignore next
export const imageUpload = (imageUploadPostRequest: ImageUploadPostRequest) => async (dispatch: AppDispatch): Promise<void> => {
  dispatch(ImageUploadLoadingAction())
  void ImageUploadService.imageUpload(
    imageUploadPostRequest,
    (imageUploadApiResponse: ImageUploadApiResponse, httpStatus: number) => {
      dispatch(
        ImageUploadUpdateAction({
          data: imageUploadApiResponse, httpStatus
        })
      )
    },
    (errorMessage, httpStatus) => {
      dispatch(ImageUploadErrorAction({ errorMessage, httpStatus }))
    }
  )
}

export const fetchGatewayInfo = (selectedGatewayId: string, assetId: string) => async (dispatch: any): Promise<void> => {
  dispatch(gatewayInfoLoadingAction())
  void gatewayInfoService(selectedGatewayId, assetId,
    (gatewayInfoData, httpStatus) => {
      dispatch(
        gatewayInfoUpdateAction({
          data: gatewayInfoData,
          httpStatus
        })
      )
    },
    (errorMessage, httpStatus) => {
      dispatch(gatewayInfoErrorAction({ errorMessage, httpStatus }))
    }
  )
}

export const updateGateway = (updateGatewayPutRequest: UpdateGatewayPutRequest) => async (dispatch: AppDispatch): Promise<void> => {
  dispatch(updateGatewayLoadingAction())
  void UpdateGatewayService.updateGateway(
    updateGatewayPutRequest,
    (UpdateGatewayApiResponse: UpdateGatewayApiResponse, httpStatus: number) => {
      dispatch(
        updateGatewayUpdateAction({
          data: UpdateGatewayApiResponse, httpStatus
        })
      )
    },
    (errorMessage, httpStatus) => {
      dispatch(updateGatewayErrorAction({ errorMessage, httpStatus }))
    }
  )
}

export const downloadImage = (assetId: string, assetTypeId: string, locale: string) => async (dispatch: any): Promise<void> => {
  dispatch(downloadImageLoadingAction())
  void downloadImageService.downloadImageService(assetId, assetTypeId, locale,
    (downloadImageData, httpStatus) => {
      dispatch(
        downloadImageUpdateAction({
          data: downloadImageData,
          httpStatus
        })
      )
    },
    (errorMessage, httpStatus) => {
      dispatch(downloadImageErrorAction({ errorMessage, httpStatus }))
    }
  )
}

export const fetchTimeZones = () => async (dispatch: any): Promise<void> => {
  dispatch(TimezoneDropDownLoadingAction())
  // eslint-disable-next-line @typescript-eslint/no-confusing-void-expression
  void timezoneService.getTimeZones(
    (timezoneData, httpStatus) => {
      dispatch(TimezoneDropDownUpdateAction({ data: timezoneData, httpStatus }))
    },
    (errorMessage, httpStatus) => {
      dispatch(TimezoneDropDownErrorAction({ errorMessage, httpStatus }))
    }
  )
}
